import type { ApiJobSynonymId } from '#/api/types/ApiTypedId';
import type { FormUsageContext } from '#/components/Form/Form';
import { StyledVersionedRouterLink } from '#/components/Link/StyledVersionedRouterLink';
import { BodySmall } from '#/components/Text/BodySmall';
import { H3 } from '#/components/Text/H3';
import { useI18n } from '#/i18n/hooks/useI18n';
import { CareerPathForm } from '#/modules/salary/components/CareerPathForm/CareerPathForm';
import type { CareerPathAnalyticsData } from '#/modules/salary/types/CareerPathAnalyticsData';
import type { EstimatedRange } from '#/modules/salary/types/EstimatedRange';
import { colors } from '#/theme/theme';

import {
  CareerPathChartHeaderContainer,
  CareerPathFormContainer,
} from './CareerPathChartHeader.styled';

type CareerPathChartHeaderProps = {
  formAnalyticsTitle: string;
  formUsageContext: FormUsageContext;
  analyticsData: CareerPathAnalyticsData;
  careerPathData: EstimatedRange[];
  salaryModelCreated: number;
  setCareerPathData: (careerPath: EstimatedRange[]) => void;
  searchApiKey: string | null;
  setSearchApiKey: (arg0: string) => void;
  selectedSynonymId: ApiJobSynonymId;
  city?: string;
  stateCode?: string;
  yearsOfExperience?: number | null;
};

export function CareerPathChartHeader({
  formAnalyticsTitle,
  formUsageContext,
  analyticsData,
  careerPathData,
  setCareerPathData,
  salaryModelCreated,
  searchApiKey,
  setSearchApiKey,
  selectedSynonymId,
  city,
  stateCode,
  yearsOfExperience,
}: CareerPathChartHeaderProps) {
  const { i18n } = useI18n();

  return (
    <CareerPathChartHeaderContainer>
      <H3 mb={0}>{i18n('Related Salaries')}</H3>

      <BodySmall color={colors.lightContentGrey} mb={0} mt={20}>
        {i18n(
          'Add more titles below to compare potential salaries! Questions? {{link}}Contact us.{{/link}}',
          { link: <StyledVersionedRouterLink to="/en/about/contact" /> },
        )}
      </BodySmall>

      <CareerPathFormContainer>
        <CareerPathForm
          analyticsTitle={formAnalyticsTitle}
          usageContext={formUsageContext}
          analyticsData={analyticsData}
          careerPathData={careerPathData}
          salaryModelCreated={salaryModelCreated}
          setCareerPathData={setCareerPathData}
          searchApiKey={searchApiKey}
          setSearchApiKey={setSearchApiKey}
          selectedSynonymId={selectedSynonymId}
          city={city}
          stateCode={stateCode}
          yearsOfExperience={yearsOfExperience}
        />
      </CareerPathFormContainer>
    </CareerPathChartHeaderContainer>
  );
}
